// Compact KPI tile used across dashboard and profile pages.

const tones = {
  dental: 'bg-dental-50 text-dental-600 ring-dental-100',
  accent: 'bg-accent-50 text-accent-600 ring-accent-100',
  blue: 'bg-blue-50 text-blue-600 ring-blue-100',
  amber: 'bg-amber-50 text-amber-600 ring-amber-100',
  red: 'bg-red-50 text-red-600 ring-red-100',
  green: 'bg-green-50 text-green-600 ring-green-100',
  ink: 'bg-ink-100 text-ink-600 ring-ink-200',
};

function StatTile({ icon: Icon, label, value, subValue, tone = 'dental' }) {
  return (
    <div className="stat-tile">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs sm:text-sm text-ink-500 mb-1 truncate">{label}</p>
          <p className="text-2xl font-bold tracking-tight text-ink-900">{value}</p>
          {subValue && <p className="text-xs sm:text-sm text-ink-500 mt-1 truncate">{subValue}</p>}
        </div>
        {Icon && (
          <div className={`shrink-0 p-2.5 rounded-xl ring-1 ${tones[tone] || tones.dental}`}>
            <Icon className="w-5 h-5" />
          </div>
        )}
      </div>
    </div>
  );
}

export default StatTile;
